import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AlertCircle } from 'lucide-react';
import Modal from './Modal';
import Button from './Button';
import { useClaimStore } from '../store/claimStore';

/**
 * DEV-8836 — shown once when the BFF refuses to save the current draft because it was abandoned
 * (or discarded as deleted) from another tab or window of the same account. Replaces the stack
 * of "Not found" toasts each auto-save used to raise: the only way out is back to the home
 * screen, where the claim list reflects the real state.
 */
const ClaimNotEditableModal: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const reason = useClaimStore((state) => state.claimNotEditable);

  if (!reason) {
    return null;
  }

  const backHome = () => {
    useClaimStore.getState().clearClaim();
    navigate('/');
  };

  return (
    <Modal
      isOpen
      onClose={backHome}
      dismissible={false}
      title={t('claimNotEditable.title')}
      size="sm"
      footer={
        <Button variant="primary" onClick={backHome}>
          {t('claimNotEditable.backHome')}
        </Button>
      }
    >
      <div className="flex items-start space-x-3">
        <AlertCircle className="w-6 h-6 text-warning-500 flex-shrink-0 mt-1" aria-hidden="true" />
        {/* One message whatever the code: the user does not need the reason (abandoned or
            deleted), only that the claim is gone. The code still tells them apart in the logs. */}
        <p className="text-gray-700">{t('claimNotEditable.message')}</p>
      </div>
    </Modal>
  );
};

export default ClaimNotEditableModal;
